import { Switch } from 'antd'
import SwitchWithDescription from '../../common/SwitchWithDescription'
import VSpace from '../../common/VSpace'
import { Action, DownPaymentActionType as ActionType, DownPaymentParameters } from '../proposalsModel'
import '../DownPayment.css'

type Props = {
  downPayment: DownPaymentParameters
  dispatch: (action: Action) => void
  redesign?: boolean
}

const PaymentMethods = ({ downPayment, dispatch, redesign = false }: Props) => {
  if (redesign) {
    return <VSpace size="large">
      <SwitchWithDescription
        checked={downPayment.enableCardPayments}
        label="Enable Card Payments"
        description="Let customers pay this proposal with a credit or debit card."
        onClick={() => dispatch({
          type: ActionType.EnableCardPaymentsChanged,
          value: !downPayment.enableCardPayments
        })}
      />
      <SwitchWithDescription
        checked={downPayment.enableBankTransfers}
        label="Enable Bank Transfers (ACH)"
        description="Let customers pay this proposal by bank transfer."
        onClick={() => dispatch({
          type: ActionType.EnableBankTransfersChanged,
          value: !downPayment.enableBankTransfers
        })}
      />
    </VSpace>
  }

  return <div className="payment-methods">
    <div>
      <Switch
        checked={downPayment.enableCardPayments}
        size="small"
        style={{ marginRight: '16px' }}
        data-testid="downPayment.enableCardPayments"
        onChange={value => dispatch({ type: ActionType.EnableCardPaymentsChanged, value })}
      />
      Enable Card Payments
    </div>
    <div>
      <Switch
        checked={downPayment.enableBankTransfers}
        size="small"
        style={{ marginRight: '16px' }}
        data-testid="downPayment.enableBankTransfers"
        onChange={value => dispatch({ type: ActionType.EnableBankTransfersChanged, value })}
      />
      Enable Bank Transfers (ACH)
    </div>
  </div>
}

export const PaymentMethodOnFileSettings = ({ downPayment, dispatch, redesign = false }: Props) => {
  if (downPayment.invoicingSystem !== 'synkedUp') {
    return null
  }

  if (redesign) {
    return <VSpace size="large">
      <SwitchWithDescription
        checked={downPayment.showAuthorizePaymentOnFile}
        label="Request Payment Method on File"
        description="Display the option for customers to authorize saving their payment method for future use."
        onClick={() => dispatch({
          type: ActionType.ShowAuthorizePaymentOnFileChanged,
          value: !downPayment.showAuthorizePaymentOnFile
        })}
      />
      {downPayment.showAuthorizePaymentOnFile && <div style={{ marginLeft: 50, borderLeft: '1px solid #00000026', paddingLeft: 12 }}>
        <SwitchWithDescription
          checked={downPayment.requireAuthorizePaymentOnFile}
          label="Require Payment Method on File"
          description="Make it required for customers to authorize saving their payment method for future use."
          onClick={() => dispatch({
            type: ActionType.RequireAuthorizePaymentOnFileChanged,
            value: !downPayment.requireAuthorizePaymentOnFile
          })}
        />
      </div>}
    </VSpace>
  }

  return <div className="payment-methods">
    <div>
      <Switch
        checked={downPayment.showAuthorizePaymentOnFile}
        size="small"
        style={{ marginRight: '16px' }}
        data-testid="downPayment.showAuthorizePaymentOnFile"
        onChange={value => dispatch({ type: ActionType.ShowAuthorizePaymentOnFileChanged, value })}
      />
      Request Payment Method on File
    </div>
    {downPayment.showAuthorizePaymentOnFile && <div>
      <Switch
        checked={downPayment.requireAuthorizePaymentOnFile}
        size="small"
        style={{ marginLeft: '44px', marginRight: '16px' }}
        data-testid="downPayment.requireAuthorizePaymentOnFile"
        onChange={value => dispatch({ type: ActionType.RequireAuthorizePaymentOnFileChanged, value })}
      />
      Require Payment Method on File
    </div>}
  </div>
}

export default PaymentMethods
